<app-navbar></app-navbar>

    <main class="hero">
        <div class="hero-container">
            <div class="hero-text-section">
                <h1 class="hero-title">Choisissez<br>votre réseau,<br>on s'occupe<br>du reste !</h1>
                <p class="hero-desc">Avec YouPrice, profitez de forfaits mobiles sans engagement sur votre réseau préféré et d'un service client qui prend vraiment soin de vous.</p>
                
                <div class="networks-container">
                    <span class="badge-networks">NOS 3 RÉSEAUX</span>
                    <div class="network-buttons">
                        <a href="/forfaits-mobile-orange/" class="btn-network btn-orange">Orange</a>
                        <a href="/forfaits-mobile-sfr/" class="btn-network btn-sfr">SFR</a>
                        <a href="/forfaits-mobile-bouygues/" class="btn-network btn-bouygues">Bouygues Telecom</a>
                    </div>
                </div>
                <a href="https://fr.trustpilot.com/review/www.youprice.fr?utm_medium=trustbox&utm_source=Mini" class="trustpilot">
                    <div class="trustpilot-rating">
          <div class="stars">
            <div class="star-box">★</div>
            <div class="star-box">★</div>
            <div class="star-box">★</div>
            <div class="star-box">★</div>
            <div class="star-box half">★</div>
          </div>
          <!-- <span>4,5 <small>• 6 244 avis</small></span> -->
        </div>
                    <span class="lbl">Excellent sur Trustpilot</span>
                </a>
            </div>
            <div class="hero-card-section">
                <div class="offers-card">
                    <div class="card-header">
                        <div class="badge-offer">
                             <!-- <span><img src="assets/img/Vector.svg" alt="badge" fetchpriority="high"></span> <p>Carte SIM à 1€</p> -->
                             <span><img src="assets/img/Vector.svg" alt="badge" fetchpriority="high"></span> <p>OFFRES DU MOMENT</p>
                        </div>
                        <!-- <div class="countdown">
                            <div class="time-box"><div class="time-val">{{ daysStr }}</div><div class="time-label">Jours</div></div>
                            <div class="time-box"><div class="time-val">{{ hoursStr }}</div><div class="time-label">Heures</div></div>
                            <div class="time-box"><div class="time-val">{{ minutesStr }}</div><div class="time-label">Minutes</div></div>
                        </div> -->
                    </div>
                    <div *ngFor="let offer of momentProducts" class="offer-item offer-{{offer.operators}}">
                        <div class="offer-details">
                            <span class="badge-5g">{{ offer.reseau }}</span>
                            <div class="data-amount">{{ offer.gigas }}</div>
                            <div class="price">
                                <span>{{ offer.maxTarif}}€</span>
                                <p>/mois</p>
                                
                            </div>
                            <!-- <div class="offer-desc"><span>Forfait {{ offer.reseau }} réseau {{ offer.operators }}</span> sans engagement</div> -->
                            <div class="offer-desc">
  <span>Forfait {{ offer.reseau }} réseau {{ operatorFormat[offer.operators] || offer.operators }}</span> sans engagement
</div>
                        </div>
                        <div class="offer-actions">
                            <button class="btn-profiter" (click)="createBasket(offer); $event.stopPropagation(); $event.preventDefault()">Profiter de l'offre</button>
                            <a  [routerLink]="['/forfaits-mobile-'+offer.operators, offer.urlName]" class="link-voir">→ Voir l'offre</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>